export default "__VITE_ASSET__CNhyadME__"